import React from 'react';
import { Button } from '@mui/material';
import type { ActionProps } from 'react-querybuilder';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

const CustomDeleteButton: React.FC<ActionProps> = ({
  disabled,
  handleOnClick,
}) => (
  <Button
    variant="outlined"
    startIcon={<DeleteForeverOutlinedIcon className="delete-icon-btn" />}
    onClick={handleOnClick}
    className="delete-btn"
    disabled={disabled}
  >
    Delete
  </Button>
);

export default CustomDeleteButton;
